import React from "react";
import PropTypes from "prop-types";

import { assetUrl } from "./assetsHelper";

class RetinaImage extends React.PureComponent {
  state = { error: false }

  onError = () => {
    this.setState({ error: true });
  }

  render() {
    const { id, filename, width, height, placeholder, ...attributes } = this.props;
    const { error } = this.state;
    const src = assetUrl(id, filename, ["fill", width, height]);
    const srcset = `${assetUrl(id, filename, ["fill", width * 2, height * 2])} 2x`;

    return error ? (
      placeholder
    ) : (
      <img
        src={src}
        srcSet={srcset}
        width={width}
        height={height}
        onError={this.onError}
        alt=""
        {...attributes}
      />
    );
  }
}

RetinaImage.propTypes = {
  id: PropTypes.string.isRequired,
  filename: PropTypes.string,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  placeholder: PropTypes.any,
};

RetinaImage.defaultProps = {
  filename: undefined,
  placeholder: null,
};

export default RetinaImage;
